module.exports = __webpack_public_path__ + "ky.532f970c6ee87a8eb909.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/ky.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/ky.svg
// module chunks = styles